'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePhoto = function ImagePhoto(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
  );
};
ImagePhoto = (0, _pure2.default)(ImagePhoto);
ImagePhoto.displayName = 'ImagePhoto';
ImagePhoto.muiName = 'SvgIcon';

exports.default = ImagePhoto;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/image/photo.js
// module id = 2460
// module chunks = 0